/* eslint-disable no-extra-boolean-cast */
import cookie from 'react-cookies';

export const saveCookieForShopify = (href: string | undefined, locale: string) => {
    if (!locale || !href) return href;
    const isShopifyLink = href.includes(`${locale}.ecoflow.com`);
    if (!isShopifyLink) return href;
    try {
        cookie.save(
            '__ecoflow_shopify_ref',
            JSON.stringify({ brand_referrer: `EcoFlow ${locale.toUpperCase()}`, page_path_referrer: location?.pathname, timestamp: Date.now() }),
            { path: '/', domain: '.ecoflow.com' },
        );
    } catch (e) {
        console.error(e);
    }
    return href;
};

export const saveAICookieForShopify = (href: string | undefined, locale: string, isAddToCart?: boolean) => {
    if (!locale || !href) return href;
    const isShopifyLink = href.includes(`${locale}.ecoflow.com`);
    if (!isShopifyLink) return href;

    try {
        if (typeof window !== 'undefined') {
            let jumpModule = 'EcoFlow Page';

            const moduleReferral = sessionStorage.getItem('ai_recommend_module') || '';

            const expires = new Date();
            expires.setDate(expires.getDate() + 7);

            if (!!moduleReferral) {
                if (!!href.includes(`${locale}.ecoflow.com/checkouts/cn`)) {
                    // 跳 Shopify结账页
                    jumpModule = 'Shopify Checkout Page';
                } else if (!!href.includes(`${locale}.ecoflow.com/products`)) {
                    // 跳 Shopify产品详情页
                    jumpModule = 'Shopify Product Details Page';
                } else if (!!href.includes(`${locale}.ecoflow.com/cart`) && !isAddToCart) {
                    // 跳转 checkout
                    jumpModule = 'Shopify Checkout Page';
                } else if (!!href.includes(`${locale}.ecoflow.com/cart`) && !!isAddToCart) {
                    // 点击 add to cart
                    jumpModule = 'Brand Shopping Cart';
                } else {
                    // 默认
                    jumpModule = 'EcoFlow Page';
                }

                // cookie.save() 会自动覆盖同名 cookie，无需提前删除
                cookie.save('module_referral', moduleReferral, {
                    path: '/',
                    domain: '.ecoflow.com',
                    expires,
                });
                cookie.save('jump_module', jumpModule, {
                    path: '/',
                    domain: '.ecoflow.com',
                    expires,
                });
                cookie.save('display_type', 'Official Website Page', {
                    path: '/',
                    domain: '.ecoflow.com',
                    expires,
                });
            }
        }
    } catch (error) {
        console.error(error);
    }
    return href;
};
